import React from "react";
import { Route, Redirect } from "react-router-dom";
import { routePermissions, Routes } from "./routes";
import { jwtDecode } from "jwt-decode";

export const ProtectedRoute = ({ component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={(props) => {
                const token = localStorage.getItem("token") || sessionStorage.getItem("token");

                // Sem token → login
                if (!token) return <Redirect to={Routes.Signin.path} />;

                try {
                    const decoded = jwtDecode(token);
                    const role =
                        decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]?.toLowerCase() ||
                        "user";
                    const isAtivo = decoded["isAtivo"] === "1";

                    // Pega a rota correta
                    const rule = routePermissions[props.match.path];

                    if (!rule) return <Component {...props} />; // pública
                    if (!rule.roles.includes(role)) return <Redirect to={Routes.Signin.path} />;
                    if (rule.requiresActive && !isAtivo) return <Redirect to={Routes.PraticantesUser.path} />;

                    return <Component {...props} />;
                } catch {
                    return <Redirect to={Routes.Signin.path} />;
                }
            }}
        />
    );
};
